import { navigate } from "gatsby"
import React, { useEffect } from "react"

import "../components/layout.scss"

export default function IndexPage() {
  useEffect(() => {
    navigate('/decision/')
  }, [])

  return <div style={{
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }}>
    loading ...
  </div>
}